import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { mobile, mobileM, tablet } from "../responsive";

//
import Aos from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
/*


This are the products on the Front page

This styles are connected to the HomeScreen.jsx


*/

const ImgContainer = styled.div`
  ${mobile({
    width: "100%",
  })}
  ${mobileM({
    width: "100%",
  })}
  ${tablet({
    width: "100%",
  })}
`;
const ImgBox = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;

  //

  //
  img {
    width: 100%;
    min-height: auto;
    object-fit: cover;
    ${mobile({ width: "100%" })}
    ${mobileM({ width: "100%" })}
  ${tablet({
      width: "100%",
    })}
  }
`;

const Product = ({ product }) => {
  //

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  //
  return (
    <ImgContainer>
      <Link to={`/product/${product._id}`}>
        <ImgBox>
          <motion.img
            data-aos="fade-up"
            whileHover={{ scale: 1.1 }}
            onHoverStart={(eImg) => {}}
            onHoverEnd={(eImg) => {}}
            src={product.image}
          />
        </ImgBox>
      </Link>
    </ImgContainer>
  );
};

export default Product;
